import { AnyObject, ValueType } from '../types';

function toString(value: AnyObject): string{
  if(value instanceof Date) value = value.toISOString();
  return value?.toString();
}

export function jsonToUri(parameters:  Record<string, ValueType | Array<ValueType>>, prefix = ''): string{
  if(!parameters) return '';

  return Object.keys(parameters)
    .filter(key => typeof parameters[key] !== undefined)
    .map(key => Array.isArray(parameters[key])? { key, values: [...(parameters[key] as Array<ValueType>)] } : {key, values: [parameters[key]] })
    .map(
      ({key, values}) =>
        values
          .filter(value => value != undefined)
          .map(value => `${prefix}${encodeURIComponent(key)}=${encodeURIComponent(toString(value))}`)
    )
    .flat()
    .join('&')
}


